export default (props) => (
  <svg width="17" height="16" fill="none" viewBox="0 0 17 16" {...props}>
    <path
      fill="currentColor"
      d="M16.4 3.34L13.66.6A2 2 0 0011 .53l-9 9a2 2 0 00-.57 1.21L1 14.91A1 1 0 002 16h.09l4.17-.38a2 2 0 001.21-.57l9-9a1.92 1.92 0 00-.07-2.71zM6.08 13.62l-3 .28.27-3L9 5.32l2.7 2.7-5.62 5.6zM13 6.68L10.32 4l1.95-2L15 4.73l-2 1.95z"
    ></path>
  </svg>
);
